module.exports = __webpack_public_path__ + "static/media/3_27.adbf8bc0.JPG";